module.exports = "https://static.wagwalking.com/_next/static/images/pet-insurer-bouncer-4e1d480924e984ee8285f7f55de98aa0.png";